import addQueryParams from './add-query-params';

export { addQueryParams };

export default addQueryParams;
